module.exports = __webpack_public_path__ + "static/logo-google-ad-manager-aec8fcf0082385e90bb0d3adcad5f99a.png";